import store from '@/store';
import axios from 'axios';
import { CLIENT_CONFIG_URL } from '@/constants';

const FAVICON_ELEMENT_ID = 'favicon';
const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const clientId = params?.client_id
  ? params.client_id
  : sessionStorage.getItem('clientID');

const API = axios.create({
  baseURL: CLIENT_CONFIG_URL
});

export const getClientConfig = async (): Promise<void> => {
  try {
    const { data } = await API.get(`/${clientId}/config.json`);
    store.dispatch('setConfig', data);
  } catch (error) {
  }
};

export const setClientFavicon = (): void => {
  const favicon: any = document.getElementById(FAVICON_ELEMENT_ID);
  favicon.href = store.getters.faviconUrl;
};
